import CONTRATO_FRENTES from '@/graphql/querys/administracion/contratos/contrato/frentes/contratoFrentes.gql';
import AGREGAR_CONTRATO_FRENTE from '@/graphql/mutations/administracion/contratos/contrato/frentes/agregarContratoFrente.gql';
import ACTUALIZAR_CONTRATO_FRENTE from '@/graphql/mutations/administracion/contratos/contrato/frentes/actualizarContratoFrente.gql';
import REMOVER_CONTRATO_FRENTE from '@/graphql/mutations/administracion/contratos/contrato/frentes/removerContratoFrente.gql';

export default {
  methods: {
    async mixRegistrarFrente() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_FRENTE,
          variables: {
            frente: this.frente,
          },
          update: (store, { data: { agregarContratoFrente } }) => {
            const query = {
              query: CONTRATO_FRENTES,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoFrentes } = store.readQuery(query);
            const contratoFrentesCopia = contratoFrentes.slice();
            contratoFrentesCopia.push(agregarContratoFrente);
            store.writeQuery({
              ...query,
              data: {
                contratoFrentes: contratoFrentesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar
    async mixActualizarFrente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_FRENTE,
          variables: {
            id: this.frenteEditar.id,
            frente: this.frente,
          },
          update: (store, { data: { actualizarContratoFrente } }) => {
            const query = {
              query: CONTRATO_FRENTES,
              variables: {
                idContrato: this.frenteEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoFrentes } = data;
            const index = contratoFrentes
              .findIndex((contratoFrente) => contratoFrente.id
              === actualizarContratoFrente.id);
            if (index !== -1) {
              contratoFrentes.splice(index, 1, actualizarContratoFrente);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar frente
    async mixEliminarFrente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_FRENTE,
        variables: {
          id: this.contratoFrente.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_FRENTES,
            variables: {
              idContrato: this.contratoFrente.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoFrentes } = data;
          const index = contratoFrentes
            .findIndex((frente) => frente.id === this.contratoFrente.id);
          if (index !== -1) {
            contratoFrentes.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
